<template>
  <path
    d="M1.52191 7.25C1.52191 6.97386 1.74577 6.75 2.02191 6.75H15.0227C15.2988 6.75 15.5227 6.97386 15.5227 7.25V8.75C15.5227 9.02614 15.2988 9.25 15.0227 9.25H2.02191C1.74577 9.25 1.52191 9.02614 1.52191 8.75V7.25Z"
    fill="currentColor" />
</template>
